import { Component, OnInit } from '@angular/core';
import { ObservationService } from '../../services/observation.service';

@Component({
    selector: 'eyewatch-observation-status-widget',
    templateUrl: './observation-status.component.html',
    styleUrls: ['./observation-status.component.scss']
})
export class ObservationStatusComponent implements OnInit {

    protected data = {
        openObservationsCreatedThisWeek: 0,
        totalOpenObservations: 0,
        totalCompletedObservations: 0,
        totalObservations: 0,
    };

    constructor(
        protected observationService: ObservationService) {
    }

    ngOnInit() {
        this.loadObservations();
    }

    protected loadObservations(): void {
        this.observationService.custom('get', this.observationService.getBaseEndpoint() + 'widgets/observation-statistics')
            .subscribe((statistics) => {
                this.data = {
                    openObservationsCreatedThisWeek: statistics['open-observations-created-this-week'],
                    totalOpenObservations: statistics['total-open-observations'],
                    totalCompletedObservations: statistics['total-completed-observations'],
                    totalObservations: statistics['total-observations'],
                };
            })
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/widgets/observation-status/observation-status.component.ts